import React from 'react'

/**
 * Protege una pagina de la aplicacion solo para admin
 * @param componente Pagina que se quiere proteger
 * @param tipo_usuario Tipo de usuario que se tiene
 * @returns 
 */
export const RutaProtegida = ({componente, tipo_usuario}) => {
	if(tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '0' || tipo_usuario === '3'){
		return componente
	}else{
		return (
			<div>No tienes permisos para acceder a esta página</div>
		)
	}
}
